import React from 'react';
import { Tabs } from '@adobe/react-spectrum';
import { DeepLinkDepthProvider, useDeepLinkDepth, useDeepLinkSegment } from './useDeepLinkSegment';

export function DeepLinkTabs({ defaultSelectedKey, onSelectionChange, children, ...rest }) {
    const depth = useDeepLinkDepth();
    const [selectedKey, setSelectedKey] = useDeepLinkSegment(defaultSelectedKey);

    const handleChange = (key) => {
        setSelectedKey(key);
        onSelectionChange?.(key);
    };

    return (
        <DeepLinkDepthProvider value={depth + 1}>
            <Tabs
                {...rest}
                defaultSelectedKey={defaultSelectedKey}
                selectedKey={selectedKey}
                onSelectionChange={handleChange}
            >
                {children}
            </Tabs>
        </DeepLinkDepthProvider>
    );
}
